export default __webpack_public_path__ + "static/header-subheader-anatomy-light-b999fe9799b6133fafc566b53d1d1b75.png";